export function getLast4(str: string): string {
  return str.substring(str.length - 4);
}
